// @flow

import { type OutgoingPayment } from '../outgoing-payment/types';
import type {UserInputValues} from '@tectonics/prs/user-input-values';

export function pixPispOutgoingPaymentMapper(userInputValues: UserInputValues): $Shape<OutgoingPayment> {
  const bankCode = userInputValues['selectedPixPispBank'];

  return {
    payment_type: 'pix-pisp',
    payment_type_code: 'pix-pisp',
    pisp: {
      bank_id: bankCode,
    },
  };
}
